import { Button, Typography } from 'antd'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const { Title, Text } = Typography

type Props = {
  onClose: () => void
}

const ApplicationSubmitted = ({ onClose }: Props) => {
  return (
    <div className="merchant-app-success">
      <div className="merchant-app-success-icon">
        <FontAwesomeIcon icon={faCheckCircle} />
      </div>
      <Title level={2} style={{ marginBottom: 8 }}>Application Submitted!</Title>
      <Text type="secondary" style={{ fontSize: 16, maxWidth: 480, marginBottom: 32, display: 'block' }}>
        We've received your SynkedUP Payments application. The review process typically takes
        1–3 business days. We'll notify you by email once your account is approved.
      </Text>
      <Button type="primary" size="large" onClick={onClose} style={{ borderRadius: 24, height: 44, padding: '0 32px' }}>
        Back to Settings
      </Button>
    </div>
  )
}

export default ApplicationSubmitted
